import {Shape} from './shape';
import {AhmService} from '../../../../services/ahm.service';

export class Circle extends Shape {

  private color = 'yellow';
  // private x = 150;
  // private y = 150;
  // private z = 100;

  public name = 'Circle';
  public type = 'KF.AHM1';
  // public id;

  constructor(private ctx: CanvasRenderingContext2D, private localName = 'circle', private x:number = 150, private y:number = 150, private z:number = 100, public id:string = 'shape_' + AhmService.prototype.makeid(10)) {
    super();
    this.name = localName;
  }

  /**
   * draw first time after created and when moving with buttons (or fixed with buttons)
   */
  draw() {
    this.ctx.fillStyle = this.color;
    this.ctx.beginPath();
    this.ctx.arc(this.x + this.z / 2, this.y + this.z / 2, this.z / 2, 0, 2 * Math.PI);
    this.ctx.closePath();
    this.ctx.fill();
    this.setText();
  }

  setText() {
    this.ctx.fillStyle = "#00F";
    this.ctx.strokeStyle = "#F00";
    this.ctx.font = "italic 10pt Arial";
    this.ctx.fillText(this.name, this.x + 30, this.y + 50);
  }

  /**
   * Draws on every move
   */
  drawOnDefPosition() {
    this.ctx.fillStyle = this.color;
    // this.x = xx;
    // this.y = yy;
    this.ctx.beginPath();
    this.ctx.arc(this.x + this.z / 2, this.y + this.z / 2, this.z / 2, 0, 2 * Math.PI);
    this.ctx.closePath();
    this.ctx.fill();
    // console.log(this.z * this.x, this.z * this.y, this.z, this.z);
    this.setText();
  }

  setName(name) {
    this.name = name;
  }

  removePicture() {
    this.ctx.fillStyle = 'black';
    this.ctx.beginPath();
    this.ctx.arc(this.x + this.z / 2, this.y + this.z / 2, this.z / 2, 0, 2 * Math.PI);
    this.ctx.closePath();
    this.ctx.fill();
  }

  drawOnPosition(xx, yy) {
  }

  putThisCoords(xx, yy) {
    this.removePicture();
    this.x = xx;
    this.y = yy;
  }

  moveRight() {
    this.removePicture();
    this.x += 10;
    this.draw();
  }

  moveLeft() {
    this.removePicture();
    this.x -= 10;
    this.draw();
  }

  moveUp() {
    this.removePicture();
    this.y -= 10;
    this.draw();
  }

  moveDown() {
    this.removePicture();
    this.y += 10;
    this.draw();
  }

  /**
   * save object state into String
   */
  serialization() {
    return ';shape,' +
        this.type + ',' +
        this.name + ',' +
        this.x + ',' +
        this.y + ',' +
        this.z + ',' +
        this.id +
        ';';
  }

}
